import checkBox from '@meettry/ui-components/images/icons/red/icon_checkbox.png';

export default {
  checkBox
};
